import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgUserinline = (props) => /* @__PURE__ */ _jsx("svg", {
	viewBox: "0 0 24 24",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M8.67 12h6.66a2 2 0 0 1 1.969 1.642l1.487 8.18A1 1 0 0 1 17.802 23H6.198a1 1 0 0 1-.984-1.179l1.487-8.179A2 2 0 0 1 8.67 12zM12 9a4 4 0 1 1 0-8 4 4 0 0 1 0 8z",
		stroke: "currentColor",
		strokeWidth: 2,
		fill: "none",
		strokeLinecap: "square",
		strokeLinejoin: "round"
	})
});
export default SvgUserinline;
